import $ from "../../components/jquery";
import Toast from "../../components/toast";
import iziToast from "izitoast";
import { abrirHistoricoReajuste } from "../cadastros/clienteReajusteIgpm/historico";

interface AvisosIgpmConfig { usuario: number; url: string; historicoUrl: string; }
interface AvisoIgpm {
    codigo: number;
    codReajuste: number;
    anoCompetencia: number;
    mesCompetencia: number;
    quantidadeSubclientes: number;
    expiraEm: string;
}

let iniciado = false;

// Consultado uma única vez ao acessar Clientes com permissão financeira.
export function iniciarAvisosIgpm(config: AvisosIgpmConfig) {
    if (iniciado || !config?.usuario || !config.url || !config.historicoUrl) return;
    iniciado = true;
    const prefixo = `thor:igpm:dispensado:${config.usuario}:`;
    const exibidos = new Map<string, HTMLDivElement>();
    const dispensados = new Set<string>();

    function chave(aviso: AvisoIgpm) { return `${aviso.codigo}:${aviso.codReajuste}`; }

    function dispensado(aviso: AvisoIgpm) {
        if (dispensados.has(chave(aviso))) return true;
        try { return Number(localStorage.getItem(prefixo + chave(aviso))) > Date.now(); }
        catch { return false; }
    }

    function exibir(aviso: AvisoIgpm) {
        const expira = Date.parse(aviso.expiraEm);
        const id = chave(aviso);
        if (!Number.isFinite(expira) || expira <= Date.now() || dispensado(aviso) || exibidos.has(id)) return;
        if (!Number.isSafeInteger(aviso.codigo) || aviso.codigo <= 0 || !Number.isSafeInteger(aviso.codReajuste)
            || aviso.codReajuste <= 0 || !Number.isSafeInteger(aviso.quantidadeSubclientes) || aviso.quantidadeSubclientes <= 0
            || !Number.isSafeInteger(aviso.anoCompetencia) || aviso.anoCompetencia < 1900
            || !Number.isInteger(aviso.mesCompetencia) || aviso.mesCompetencia < 1 || aviso.mesCompetencia > 12) return;
        Toast.warning("Reajuste automático IGP-M", undefined, "topRight", {
            id: `igpm-aviso-${aviso.codigo}-${aviso.codReajuste}`,
            timeout: 0,
            displayMode: 0,
            closeOnClick: false,
            onOpening: (_, toast) => {
                const message = toast.querySelector(".iziToast-message");
                if (message) message.textContent = `${aviso.quantidadeSubclientes} subclientes reajustados automaticamente por IGP-M na competência ${String(aviso.mesCompetencia).padStart(2, "0")}/${aviso.anoCompetencia}. Clique para consultar o histórico.`;
                exibidos.set(id, toast);
                const close = toast.querySelector(".iziToast-close");
                close?.addEventListener("click", (event) => event.stopPropagation());
                toast.addEventListener("click", (event) => {
                    if ((event.target as Element)?.closest(".iziToast-close")) return;
                    abrirHistoricoReajuste({
                        url: config.historicoUrl,
                        anoCompetencia: aviso.anoCompetencia,
                        mesCompetencia: aviso.mesCompetencia,
                        codReajusteSelecionado: aviso.codReajuste
                    });
                });
                window.setTimeout(() => {
                    if (exibidos.get(id) === toast) iziToast.hide({}, toast, "expirado");
                }, Math.min(expira - Date.now(), 2147483647));
            },
            onClosing: (_, toast, closedBy) => {
                if (closedBy === "button") {
                    dispensados.add(id);
                    try { localStorage.setItem(prefixo + id, String(expira)); } catch { /* Mantém dispensa na sessão. */ }
                }
                if (exibidos.get(id) === toast) exibidos.delete(id);
            }
        });
    }

    window.addEventListener("storage", (event) => {
        if (!event.key?.startsWith(prefixo) || Number(event.newValue) <= Date.now()) return;
        const id = event.key.substring(prefixo.length);
        dispensados.add(id);
        const toast = exibidos.get(id);
        if (toast) iziToast.hide({}, toast, "outra-sessao");
    });
    $.ajax({ url: config.url, type: "GET", global: false })
        .done((avisos: AvisoIgpm[]) => {
            if (Array.isArray(avisos)) avisos.forEach(exibir);
        });
}
